import SupplierManagement from "@/models/loyaltyPanel/SupplierManagement";
import SupplierNotificationMessage from "@/models/loyaltyPanel/SupplierNotificationMessage"

export default {
    namespaced: true,

    state: () => ({
        suppliers: [],
        supplier: new SupplierManagement(),
        countries: [],
        messageBody: new SupplierNotificationMessage()
    }),

    mutations: {
        setSuppliers(state, payload) {
            state.suppliers = payload;
        },
        setSupplier(state, payload) {
            state.supplier = new SupplierManagement(payload);
        },
        setCountries(state, payload) {
            state.countries = payload;
        },
        setMessageBody(state, payload) {
            state.messageBody = new SupplierNotificationMessage(payload);
        }
    },

    actions: {
        async getSuppliers({ commit }) {
            try {
                commit("setLoading", true, { root: true });

                const { data } = await SupplierManagement.get();
                const suppliers = data.data;
                commit("setSuppliers", suppliers);
                commit("setLoading", false, { root: true });
            } catch (ex) {
                commit("setLoading", false, { root: true });
            }
        },

        async getCountries({ commit }) {
            try {
                commit("setLoading", true, { root: true });

                const { data } = await SupplierManagement.getCountries();
                const countries = data.data;
                commit("setCountries", countries);
                commit("setLoading", false, { root: true });
            } catch (ex) {
                commit("setLoading", false, { root: true });
            }
        },

        async getMessage({ commit }) {
            try {
                commit("setLoading", true, { root: true });

                const { data } = await SupplierManagement.getMessage();
                
                commit("setMessageBody", data.data);
                commit("setLoading", false, { root: true });
            } catch (ex) {
                commit("setLoading", false, { root: true });
            }
        },

        async create({ commit, state, dispatch }) {
            try {
                commit("setLoading", true, { root: true });

                await SupplierManagement.create(state.supplier);

                dispatch("getSuppliers");
                commit("setLoading", false, { root: true });
                commit("setDialog", false, { root: true });
                commit(
                    "setNotification",
                    {
                        show: true,
                        type: "success",
                        text: "You have successfully created Supplier!"
                    },
                    { root: true }
                );
            } catch (ex) {
                commit("setLoading", false, { root: true });
                commit("setErrorMessage", ex.response.data.message, {
                    root: true
                });
                setTimeout(
                    () => commit("setErrorMessage", "", { root: true }),
                    5000
                );
            }
        },

        async updateMessage({ commit, state, dispatch }, body) {
            try {
                commit("setLoading", true, { root: true });

                await SupplierManagement.updateMessage(body);

                dispatch("getMessage");
                commit("setLoading", false, { root: true });
                commit(
                    "setNotification",
                    {
                        show: true,
                        type: "success",
                        text: "You have successfully updated Notification Message!"
                    },
                    { root: true }
                );
            } catch (ex) {
                commit("setLoading", false, { root: true });
                commit("setErrorMessage", ex.response.data.message, {
                    root: true
                });
                setTimeout(
                    () => commit("setErrorMessage", "", { root: true }),
                    5000
                );
            }
        },

        async delete({ commit, dispatch }, id) {
            try {
                commit("setLoading", true, { root: true });

                await SupplierManagement.delete(id);

                dispatch("getSuppliers");
                commit("setDeleteDialog", false, { root: true });
                commit(
                    "setNotification",
                    {
                        show: true,
                        type: "success",
                        text: "You have successfully deleted Supplier!"
                    },
                    { root: true }
                );
                commit("setLoading", false, { root: true });
            } catch (ex) {
                commit("setLoading", false, { root: true });
                commit("setErrorMessage", ex.response.data.message, {
                    root: true
                });
                setTimeout(
                    () => commit("setErrorMessage", "", { root: true }),
                    5000
                );
            }
        }

    }
};
